/**
 * NOTE: this constant is used instead of a whole leaf node for home-page.view
 *       only TH is allowed to have offers on homepage (even if they enable
 *       the flag) because offers ui v2.0 was intentionally not scoped to work
 *       on the homepage. this ensures that even if a brand turns on the flag,
 *       they won't accidentally add broken UI to their homepage
 */
export const BRAND_ALLOWED_OFFERS_ON_HOMEPAGE = false;
